export class Blog {
  public id: string;
  public blogId: number;
  public blogCategoryId: number;
  public userId: number;
  public blogStatus: string;
  public name: string;
  public detail: string;
  public shortDetail: string;
  public url: string;
  public sortOrder: number;
  public blogLogo: string;
  public createdDate: Date;
  public updatedDate: Date;
  public isActive: boolean;
  public blogCategoryName: string;
  public metaTitle: string;
  public metaKeyword: string;
  public metaDescription: string;
}




// WEBPACK FOOTER //
// ./src/app/models/blog/blog-model.ts